import { Injectable, inject, effect, runInInjectionContext, Injector } from '@angular/core';
import { DepositService } from '../deposit/deposit.service';
import { RoomListService } from '../room-list/room-list.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class DepositWatcherService {
  private depositService = inject(DepositService);
  private roomListService = inject(RoomListService);
  private toastService = inject(ToastService);
  private injector = inject(Injector);

  blockToaster = false;

  async initialise(): Promise<void> {
    runInInjectionContext(this.injector, () => {
      effect(async () => {
        const consumedDeposit = this.depositService.consumedDeposit()();
        if (consumedDeposit && consumedDeposit.roomId) {
          await this.roomListService.addRoom(consumedDeposit.roomId, consumedDeposit.gameId);

          if (!this.blockToaster) {
            this.toastService.showGoToMatchToast(consumedDeposit.gameId, consumedDeposit.roomId);
          }
        }
      });
    });
  }
}
